/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Branch } from '../models/Branch';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class BranchService {
    /**
     * Get branch by ID
     * @param id
     * @returns Branch Branch found
     * @throws ApiError
     */
    public static getBranchById(
        id: string,
    ): CancelablePromise<Branch> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/branches/{id}',
            path: {
                'id': id,
            },
            errors: {
                404: `Branch not found`,
            },
        });
    }
    /**
     * Delete a branch by ID
     * @param id
     * @returns void
     * @throws ApiError
     */
    public static deleteBranchById(
        id: string,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/branches/{id}',
            path: {
                'id': id,
            },
            errors: {
                404: `Branch not found`,
            },
        });
    }
    /**
     * Get list of branches by user ID with pagination
     * @param userId
     * @param page
     * @param pageSize
     * @returns any List of branches
     * @throws ApiError
     */
    public static listBranchesByUser(
        userId: string,
        page: number = 1,
        pageSize: number = 10,
    ): CancelablePromise<{
        /**
         * Total number of branches
         */
        total?: number;
        /**
         * Current page number
         */
        page?: number;
        /**
         * Number of items per page
         */
        page_size?: number;
        branches?: Array<Branch>;
    }> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/branches',
            query: {
                'user_id': userId,
                'page': page,
                'page_size': pageSize,
            },
            errors: {
                400: `Invalid query parameters`,
            },
        });
    }
    /**
     * Create a new branch
     * @param requestBody
     * @returns Branch Branch created
     * @throws ApiError
     */
    public static createNewBranch(
        requestBody: {
            name: string;
            user_id: string;
            model_id?: string;
        },
    ): CancelablePromise<Branch> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/branches',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Invalid input`,
            },
        });
    }
}
